import { eventsQueryOptions } from "@/api/events.api";
import { Feed } from "@/components/feed";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/feed")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(eventsQueryOptions),
  component: Feed,
});
